import { ProductDetailsPage } from "@clinic/emerson/scenes/ProductDetailsPage/ProductDetailsPage";

import { loader } from "./loader";
import { meta } from "./meta";

export default () => {
  return <ProductDetailsPage />;
};

export { loader, meta };
